let urlStr = 'https://ysb.emof.cn/index.php/' //
    let urlStr1 = 'http://pz.hbanxiang.com' //
    // let urlStr1 = 'http://192.168.2.199:8025' //




export const localAnStore = [
  {
    key: 'user',
    type: 'localStorage'
  },
  {
    key: 'emofUserTokenSafer',
    type: 'cookie',
    day: 365,
    path: '/',
  },
  {
    key: 'cookie_user',
    type: 'cookie',
    day: 365,
    path: '/',
  }, //全局标识

]
export default {
  urlStr,
  urlStr1
}
